import { Moment }   from 'moment/moment';
import {
  DuplicatePaymentRequest,
  DuplicatePaymentsType,
  PaymentFormData,
}                   from '~domain/types';
import { DatePipe } from '~shared/pipes';

export type DuplicatePaymentCheckValue = {
  clientId: string;
  request: DuplicatePaymentRequest;
};

export function duplicatePaymentWarningKey(type: DuplicatePaymentsType | null) {
  return type == null ? null : 'DUPLICATE_PAYMENT_' + type.toUpperCase();
}

export function duplicatePaymentWarningTranslateArgs(datePipe: DatePipe, latestDate: Date | null) {
  return latestDate == null ? null : { date: datePipe.transform(latestDate) };
}

export function getDuplicatePaymentCheckValue(
  payment: PaymentFormData | null | undefined,
  options?: {
    mode?: 'pay' | 'assign' | 'delete';
    request?: Partial<DuplicatePaymentRequest>;
  },
): DuplicatePaymentCheckValue | null {
  if (
    (options?.mode != null && options.mode !== 'pay')
    || !payment?.clientId
    || payment.amount == null
    || !payment.beneficiary?.counterpartReference
  ) {
    return null;
  }

  return {
    clientId: payment.clientId,
    request: {
      ...options?.request,
      amount: payment.amount,
      counterpartReference: payment.beneficiary.counterpartReference,
      executionDate: payment.executionDate,
    },
  };
}

export function sameDuplicatePaymentCheck(
  prev: DuplicatePaymentCheckValue | null,
  next: DuplicatePaymentCheckValue | null,
) {
  if (prev === null || next === null) {
    return prev === next;
  }

  return prev.clientId === next.clientId
    && prev.request.amount === next.request.amount
    && prev.request.counterpartReference === next.request.counterpartReference
    && duplicatePaymentDateString(prev.request.executionDate) === duplicatePaymentDateString(next.request.executionDate);
}

function duplicatePaymentDateString(date?: Moment | null) {
  return date?.format?.('YYYY-MM-DD') ?? null;
}
